'use client';

import { Button } from '@/components/ui/button';
import { IconSearchOff } from '@tabler/icons-react';
import { ProjectsFiltersState } from '@/lib/projects/project-types';

interface ProjectsEmptyStateProps {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  onTryExample: (patch: Partial<ProjectsFiltersState>) => void;
}

export function ProjectsEmptyState({
  hasActiveFilters,
  onClearFilters,
  onTryExample,
}: ProjectsEmptyStateProps) {
  return (
    <div className="p-12 text-center">
      <IconSearchOff className="size-12 text-muted-foreground/50 mx-auto mb-4" />
      <p className="text-lg font-medium mb-1">No projects found</p>
      <p className="text-sm text-muted-foreground mb-6">
        Try adjusting filters or searching by organisation.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {hasActiveFilters && (
          <Button variant="default" size="sm" onClick={onClearFilters}>
            Clear filters
          </Button>
        )}
        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            onTryExample({ selectedOrganizations: ['World Bank'] })
          }
        >
          Try &ldquo;World Bank&rdquo;
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onTryExample({ cfpMode: 'hasCfp' })}
        >
          Try &ldquo;Has CFP&rdquo;
        </Button>
      </div>
    </div>
  );
}
